import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatableDirective } from './translatable.directive';
import { TranslatePipe } from './translate.pipe';
import { TranslationDialogComponent } from './translation-dialog/translation-dialog.component';
import { TranslationInputComponent } from './translation-input/translation-input.component';
import { TranslationLengthPipe } from './translation-length.pipe';
import { TranslatorToggleComponent } from './translator-toggle/translator-toggle.component';
import { TranslatorComponent } from './translator.component';

@NgModule({
  declarations: [
    TranslationDialogComponent,
    TranslationInputComponent,
    TranslatableDirective,
    TranslatorToggleComponent,
    TranslatorComponent,
    TranslationLengthPipe,
    TranslatePipe,
  ],
  exports: [
    TranslatableDirective,
    TranslatorToggleComponent,
    TranslatorComponent,
    TranslatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatBadgeModule,
  ],
})
export class TranslationModule {}
